import React from "react";
import {
  StyledFormGroup,
  StyledLabel,
  StyledCheckboxGroup,
  StyledCheckbox
} from "./styles";
import { FormGrid, FullWidthFormGroup } from "./styles";
import {
  RotaCheckbox,
  RotaInput,
  RotaSelect,
  RotaTextarea
} from "@teamrota/rota-design";

const BannerFormFields = ({ formData, handleChange, handlePlatformChange }) => {
  return (
    <>
      <FormGrid>
        <StyledFormGroup>
          <StyledLabel>Status *</StyledLabel>
          <RotaSelect
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="DRAFT">Draft</option>
            <option value="ACTIVE">Active</option>
            <option value="PAUSED">Paused</option>
          </RotaSelect>
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Variant</StyledLabel>
          <RotaSelect
            name="variant"
            value={formData.variant}
            onChange={handleChange}
          >
            <option value="INFO">Info</option>
            <option value="SUCCESS">Success</option>
            <option value="WARNING">Warning</option>
            <option value="ANNOUNCEMENT">Announcement</option>
          </RotaSelect>
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Audience *</StyledLabel>
          <RotaSelect
            name="audience"
            value={formData.audience}
            onChange={handleChange}
          >
            <option value="ALL">All Candidates</option>
            <option value="CANDIDATES_WITHOUT_PREFERENCES">
              Candidates Without Preferences
            </option>
            <option value="CANDIDATES_ELIGIBLE_FOR_PREFERENCES">
              Candidates Eligible For Preferences
            </option>
          </RotaSelect>
        </StyledFormGroup>
      </FormGrid>

      <FormGrid>
        <StyledFormGroup>
          <StyledLabel>Title (optional)</StyledLabel>
          <RotaInput
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="e.g., New Feature!"
            wrapperStyles={{ margin: 0 }}
          />
        </StyledFormGroup>
      </FormGrid>

      <FullWidthFormGroup>
        <StyledLabel>Message *</StyledLabel>
        <RotaTextarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Find the right shifts by adding your Preferences"
          rows={3}
          required
          wrapperStyles={{ margin: 0 }}
        />
      </FullWidthFormGroup>

      <FormGrid>
        <StyledFormGroup>
          <StyledLabel>Platforms *</StyledLabel>
          <StyledCheckboxGroup>
            <RotaCheckbox
              isChecked={formData.platforms.includes("ios")}
              onClick={() => handlePlatformChange("ios")}
              label={"iOS"}
            />
            <RotaCheckbox
              isChecked={formData.platforms.includes("android")}
              onClick={() => handlePlatformChange("android")}
              label={"Android"}
            />
          </StyledCheckboxGroup>
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Deeplink (e.g., rota://preferences)</StyledLabel>
          <RotaInput
            name="deeplink"
            value={formData.deeplink}
            onChange={handleChange}
            placeholder="rota://preferences"
            wrapperStyles={{ margin: 0 }}
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>External URL (alternative to deeplink)</StyledLabel>
          <RotaInput
            name="externalUrl"
            value={formData.externalUrl}
            onChange={handleChange}
            placeholder="https://example.com"
            wrapperStyles={{ margin: 0 }}
          />
        </StyledFormGroup>
      </FormGrid>
      <FormGrid>
        <StyledFormGroup>
          <StyledLabel>Start Date & Time</StyledLabel>
          <RotaInput
            type="datetime-local"
            name="startsAt"
            value={formData.startsAt}
            onChange={handleChange}
            wrapperStyles={{ margin: 0 }}
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>End Date & Time</StyledLabel>
          <RotaInput
            type="datetime-local"
            name="endsAt"
            value={formData.endsAt}
            onChange={handleChange}
            wrapperStyles={{ margin: 0 }}
          />
        </StyledFormGroup>
      </FormGrid>
      <FormGrid>
        <StyledFormGroup>
          <StyledLabel>Min App Version</StyledLabel>
          <RotaInput
            name="minAppVersion"
            value={formData.minAppVersion}
            onChange={handleChange}
            placeholder="1.0.0"
            wrapperStyles={{ margin: 0 }}
          />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Max App Version</StyledLabel>
          <RotaInput
            name="maxAppVersion"
            value={formData.maxAppVersion}
            onChange={handleChange}
            placeholder="2.0.0"
            wrapperStyles={{ margin: 0 }}
          />
        </StyledFormGroup>
      </FormGrid>

      <FullWidthFormGroup>
        <StyledCheckbox>
          <RotaCheckbox
            isChecked={formData.dismissible}
            onClick={handleChange}
            name="dismissible"
            label={"Dismissible (users can close this banner)"}
            style={{ marginRight: 0 }}
          />
        </StyledCheckbox>
      </FullWidthFormGroup>
    </>
  );
};

export default BannerFormFields;
